var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 4.88889C12.875 4.39797 12.4832 4 12 4C11.5168 4 11.125 4.39797 11.125 4.88889L11.125 16.9651L6.49372 12.2603C6.15201 11.9132 5.59799 11.9132 5.25628 12.2603C4.91457 12.6075 4.91457 13.1703 5.25628 13.5174L11.3813 19.7396C11.723 20.0868 12.277 20.0868 12.6187 19.7396L18.7437 13.5174C19.0854 13.1703 19.0854 12.6075 18.7437 12.2604C18.402 11.9132 17.848 11.9132 17.5063 12.2604L12.875 16.9651L12.875 4.88889Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.9256e8405f429c7a3f1de337b1158dd6.svg";
export { ForwardRef as ReactComponent };